import {EntityWithAuditMetadata} from '../../../../../common/entity/entityWithAuditMetadata';
import {PartnerSummaryModel} from '../../../../common/api/model/partnerSummary.model';

export class PartnerNote extends EntityWithAuditMetadata{
    id: number;
    partner: PartnerSummaryModel;
    content: string;
    sticky: boolean;
    color: string;
}
